/** @jsxImportSource theme-ui */
import { Container, Heading } from 'theme-ui';
import CreateUsage from '@/containers/ExtraInvoice/CreateUsage';
import { useParams, useNavigate } from 'react-router-dom';

const CreateUsagePage = () => {
    const { companyId } = useParams<{ companyId: string }>();
    const navigate = useNavigate();

    return (
        <Container>
            <Heading sx={{ textTransform: 'capitalize' }} as="h2">
                Create usage
            </Heading>
            <CreateUsage companyId={companyId} onSubmitSuccess={() => navigate(-1)} />
        </Container>
    );
};

export default CreateUsagePage;
